// import logo from './logo.svg';
import './App.css';
import Navigation from './routing';

function App() {
  return (
    <div className="">
      <Navigation/>
    </div>
  );
}

export default App;
